/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignAgentsRequest,
  AuthorizationStatus,
  LockAgentsRequest,
  Status,
} from '../models';
import {
    AssignAgentsRequestFromJSON,
    AssignAgentsRequestToJSON,
    AuthorizationStatusFromJSON,
    AuthorizationStatusToJSON,
    LockAgentsRequestFromJSON,
    LockAgentsRequestToJSON,
    StatusFromJSON,
    StatusToJSON,
} from '../models';

export interface AssignAgentsOperationRequest {
    id: number;
    assignAgentsRequest: AssignAgentsRequest;
    authorization?: string;
    onBehalfOf?: string;
}

export interface LockAgentsOperationRequest {
    lockAgentsRequest: LockAgentsRequest;
    authorization?: string;
    onBehalfOf?: string;
}

/**
 * 
 */
export class AgentsApi extends runtime.BaseAPI {

    /**
     * Assign agents to group
     */
    async assignAgentsRaw(requestParameters: AssignAgentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Status>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling assignAgents.');
        }

        if (requestParameters.assignAgentsRequest === null || requestParameters.assignAgentsRequest === undefined) {
            throw new runtime.RequiredError('assignAgentsRequest','Required parameter requestParameters.assignAgentsRequest was null or undefined when calling assignAgents.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.onBehalfOf !== undefined && requestParameters.onBehalfOf !== null) {
            headerParameters['On-Behalf-Of'] = String(requestParameters.onBehalfOf);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/agents/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssignAgentsRequestToJSON(requestParameters.assignAgentsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusFromJSON(jsonValue));
    }

    /**
     * Assign agents to group
     */
    async assignAgents(requestParameters: AssignAgentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Status> {
        const response = await this.assignAgentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lock or unlock agents
     */
    async lockAgentsRaw(requestParameters: LockAgentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Status>> {
        if (requestParameters.lockAgentsRequest === null || requestParameters.lockAgentsRequest === undefined) {
            throw new runtime.RequiredError('lockAgentsRequest','Required parameter requestParameters.lockAgentsRequest was null or undefined when calling lockAgents.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.onBehalfOf !== undefined && requestParameters.onBehalfOf !== null) {
            headerParameters['On-Behalf-Of'] = String(requestParameters.onBehalfOf);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/agents:lock`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LockAgentsRequestToJSON(requestParameters.lockAgentsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusFromJSON(jsonValue));
    }

    /**
     * Lock or unlock agents
     */
    async lockAgents(requestParameters: LockAgentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Status> {
        const response = await this.lockAgentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
